import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { useThemeA } from "../../internal/ThemeAContext";

const Pressable = forwardRef(function Pressable({ children, className = "", dataComponent = "pressable", inheritFont = false, type = "button", ...props }, ref) {
  useThemeA("Pressable");

  return (
    <button
      {...props}
      className={`akv:border-0 ${inheritFont ? "" : "akv:font-ak-body"} ${className}`.trim()}
      data-ak-v2-component={dataComponent}
      ref={ref}
      type={type}
    >
      {children}
    </button>
  );
});

Pressable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataComponent: PropTypes.string,
  inheritFont: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export { Pressable };
export default Pressable;
